import React from 'react';
import { BuyButton } from './BuyButton';
import { SITE } from '../lib/config';
export function Header() {
  return <header className="absolute top-0 left-0 right-0 z-20" data-id="element-65" data-mp="2dnfje94b8so0">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-6 md:px-10 md:py-8" data-id="element-66" data-mp="2ilh4t0p7l42n">
        <a href="#" className="inline-flex items-center rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-ink/40" aria-label={SITE.brand} data-id="element-67" data-mp="2nkajgwg8f14e">
          <img src="https://cdn.magicpatterns.com/uploads/gTvcRKJeZHMufctWHFFERk/Logo_RT.png" alt="Respira Tranquilidad" className="h-12 w-auto object-contain md:h-14" data-id="element-68" data-mp="2wkywpoxswxg8" />
        </a>
        <BuyButton variant="outline" size="md" data-id="element-69" data-mp="36a0bxcwivat5">
          Quiero el ebook
        </BuyButton>
      </div>
    </header>;
}